module.exports = __webpack_public_path__ + "media/images/mypage/icon/white/ico_seminar-fd1a1e66eae8eb08ec5ce3b8e771a39d.svg";